<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('ProjectSettings|Ownership Transfer') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'ProjectSettings|Ownership transfer allows the current project owner to transfer project ownership to another member. This is useful when project leadership changes or when the owner needs to delegate full project control.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|How It Works') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|As the project owner, you can create an ownership transfer proposal to another project member. The proposed new owner will receive a notification in their Direct Messages with the bot and can accept or decline the transfer.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|Transfer Process') }}</h4>
            <ul style="margin: 0 0 16px 0; padding-left: 20px; color: #666">
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Create a transfer proposal to a project member') }}
              </li>
              <li style="margin-bottom: 8px">
                {{
                  s__(
                    'ProjectSettings|The proposed owner receives a notification and can accept or decline'
                  )
                }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Once accepted, ownership is immediately transferred') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|The previous owner becomes an admin member') }}
              </li>
            </ul>

            <h4>{{ s__('ProjectSettings|Owner Permissions') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|The project owner has full control over the project, including the ability to manage members, archive the project, and transfer ownership. Only the owner can create ownership transfer proposals.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|Important Notes') }}</h4>
            <ul style="margin: 0 0 16px 0; padding-left: 20px; color: #666">
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Ownership transfer is permanent and cannot be undone') }}
              </li>
              <li style="margin-bottom: 8px">
                {{
                  s__(
                    'ProjectSettings|The new owner gains all owner permissions immediately upon acceptance'
                  )
                }}
              </li>
              <li style="margin-bottom: 8px">
                {{
                  s__(
                    'ProjectSettings|Proposals expire if not accepted within a certain time period'
                  )
                }}
              </li>
            </ul>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('ProjectSettings|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}

.info-section ul {
  line-height: 1.6;
}
</style>
